import React from 'react';

import { MainLayout } from '@/components/Layouts/MainLayout/MainLayout';
import { MainView } from '@repo/ui/Views';
import PageNotFound from '../components/PageNotFound';

const DidsPage = () => {
  return (
    <MainLayout>
      <MainView title="Page not found">
        <PageNotFound />
      </MainView>
    </MainLayout>
  );
};

export default DidsPage;
